<!-- Header -->
<div class="header-info">
  <h4>Export Report Information to Excel</h4>
  <p>
    Pick a Template from Dropdown Menu and press "Export" to pick a .xlsx File
  </p>
</div>

<!-- Search by Template -->
<div class="dropdown">
  <input-search placeholder="Search by Template Name" (valueChange)="searchTemplate($event)"
    [provider]="templateProvider"></input-search>
</div>

<!-- Export Button -->
<div class="uploader">
  <button [disabled]="!(templateId && chromeAppInstalled)" type="button" class="btn btn-rbv wide" (click)="requestFile()">
    <fa name="fa fa-upload"></fa>
    Pick File to Export
  </button>
</div>

<!-- Export Progress -->
<div class="progress-upload" *ngIf="STAGES.SELECTED">
  <table class="table table-bordered">
    <tbody>
      <!-- Selected -->
      <tr *ngIf="STAGES.SELECTED">
        <td class="heading">File Selected</td>
        <td class="value" [ngClass]="{
                      'fail': STAGES.SELECTED === 'FAILED',
                      'success': STAGES.SELECTED === 'SUCCESS',
                      'in-progress': STAGES.SELECTED === 'IN PROGRESS'
                      }">
          {{STAGES.SELECTED}}
        </td>
      </tr>

      <!-- Sent -->
      <tr *ngIf="STAGES.SENT">
        <td class="heading">Sent Processing</td>
        <td class="value" [ngClass]="{
                      'fail': STAGES.SENT === 'FAILED',
                      'success': STAGES.SENT === 'SUCCESS',
                      'in-progress': STAGES.SENT === 'IN PROGRESS'
                      }">
          {{STAGES.SENT}}
        </td>
      </tr>

      <!-- Received -->
      <tr *ngIf="STAGES.RECEIVED">
        <td class="heading">Received Processed</td>
        <td class="value" [ngClass]="{
                      'fail': STAGES.RECEIVED === 'FAILED',
                      'success': STAGES.RECEIVED === 'SUCCESS',
                      'in-progress': STAGES.RECEIVED === 'IN PROGRESS'
                      }">
          {{STAGES.RECEIVED}}
        </td>
      </tr>

      <!-- File Write -->
      <tr *ngIf="STAGES.WRITE">
        <td class="heading">File Write</td>
        <td class="value" [ngClass]="{
                      'fail': STAGES.WRITE === 'FAILED',
                      'success': STAGES.WRITE === 'SUCCESS',
                      'in-progress': STAGES.WRITE === 'IN PROGRESS'
                      }">
          {{STAGES.WRITE}}
        </td>
      </tr>

      <!-- Completed -->
      <tr *ngIf="STAGES.RESULT === 'Completed'">
        <td colspan="2" class="result completed">Completed</td>
      </tr>

      <!-- Failed -->
      <tr *ngIf="STAGES.RESULT === 'Failed'">
        <td colspan="2" class="result fail">Failed</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Retry button -->
<div class="uploader" *ngIf="allowFileHandleRetry === true && appData">
  <button [disabled]="!(templateId && chromeAppInstalled)" type="button" class="btn btn-rbv warning wide" (click)="retryFileChoose()">
    <fa name="fa fa-floppy-o"></fa>
    Pick File to ReTry
  </button>
</div>

<!-- Export History -->
<div class="row mt-3" *ngIf="exportHistory.length !== 0">
    <table class="table">
    <thead>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">File Name</th>
        <th scope="col">Template</th>
        <th scope="col">Server State</th>
        <th scope="col">Client State</th>
        <th scope="col">User</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let h of exportHistory; let i = index">
        <td>{{h.EXPORT_DATE | date: 'MM/dd/yyyy hh:mm a'}}</td>
        <td>{{h.FILE_NAME}}</td>
        <td>{{h.TEMPLATE.getName()}}</td>
        <td><span [ngStyle]="{'color': h.STATE_SERVER === 'SUCCESS' ? 'green' : 'red'}">{{h.STATE_SERVER}}</span></td>
        <td><span [ngStyle]="{'color': h.STATE_CLIENT === 'SUCCESS' ? 'green' : 'red'}">{{h.STATE_CLIENT}}</span></td>
        <td>
          <div style="display: flex; align-items: center;">
               <ngx-avatar [name]="h.USER.getName()" size="30"></ngx-avatar>
               <span class="ml-2">{{h.USER.getName()}}</span>
          </div>
         </td>
      </tr>
    </tbody>
  </table>
</div>
